/**
 * Category Setup API - Dataverse Integration
 */

import { MiddlewareAPI } from "@/lib/axios";
import { ICommonListApiRes, ICommonQueryParams, NetworkMethodEnum } from "@/types";
import { fetcher } from "@/utils/api/dataverse/fetcher";
import { mutator } from "@/utils/api/dataverse/mutator";
import { generateQueryParamsForPagination } from "@/utils/pagination";
import { ICategory, ICategoryForm } from "../types/categorySetup";

export const URL = {
  categories: "/Dogma_CategoryApi",
};

/**
 * Get category list with pagination from Dataverse
 */
export const getCategorySetupList = async (
  queryParams?: ICommonQueryParams
): Promise<ICommonListApiRes<ICategory>> => {
  const query = generateQueryParamsForPagination(queryParams);
  return await fetcher(
    `${URL.categories}${query}&$orderby=createdon desc`,
    queryParams?.pageSize
  );
};

/**
 * Get single category by ID from Dataverse
 */
export const getCategorySetupDetail = async (id: string): Promise<ICategory> => {
  return await fetcher(`${URL.categories}(${id})`);
};

/**
 * Create new category in Dataverse
 */
export const createCategorySetup = async (
  data: ICategoryForm
): Promise<ICategory> => {
  return await mutator(NetworkMethodEnum.POST, URL.categories, data);
};

/**
 * Update existing category in Dataverse
 */
export const updateCategorySetup = async (data: {
  id: string;
  payload: Partial<ICategoryForm>;
}): Promise<ICategory> => {
  const updatePayload = {
    id: data.id,
    ...data.payload,
  };
  return await mutator(NetworkMethodEnum.PATCH, URL.categories, updatePayload);
};

/**
 * Delete category from Dataverse
 */
export const deleteCategorySetup = async (id: string): Promise<void> => {
  await MiddlewareAPI.delete(URL.categories, {
    data: { id },
  });
};
